import axios from 'axios'
import Utils from '@/common/Utils'

const headers = { 'Content-Type': 'application/json' }

const url = `${process.env.VUE_APP_UTILS_API}/api`

export default class RegionsService {
    static async getCountries (params) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/countries`, { headers, params })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getStates (countryCode = '') {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/states/${countryCode}`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getLocations (stateCode = '') {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/locations/${stateCode}`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getColonies (postalCode = '') {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/colonies/${postalCode}`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }
}
